import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "guide-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "cards-wrapper cards-login-wrapper"
}
const _hoisted_3 = { class: "item-title" }
const _hoisted_4 = { class: "value-wrapper" }
const _hoisted_5 = { class: "item-wrapper" }
const _hoisted_6 = { class: "item-wrapper-num" }
const _hoisted_7 = { class: "item-wrapper" }
const _hoisted_8 = { class: "item-wrapper-num" }
const _hoisted_9 = { class: "item-icon" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "card-item" }
const _hoisted_12 = { class: "value-wrapper" }
const _hoisted_13 = { class: "item-wrapper" }
const _hoisted_14 = { class: "item-wrapper-num" }
const _hoisted_15 = { class: "item-icon" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "card-item renewal-card" }
const _hoisted_18 = { class: "item-nums" }
const _hoisted_19 = { class: "item-icon" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "cards-wrapper"
}
const _hoisted_22 = { class: "item-title" }
const _hoisted_23 = { class: "item-nums" }
const _hoisted_24 = { class: "unit" }
const _hoisted_25 = { class: "item-icon" }
const _hoisted_26 = ["src"]

import { onMounted, onUnmounted, ref, computed } from "vue";
import MaintenanceIcon from "@/assets/img/maintenance-icon.png";
import FaultIcon from "@/assets/img/fault-icon.png";
import AccidentIcon from "@/assets/img/accident-icon.png";
import RenewalIcon from "@/assets/img/renewal-icon.png";
import store from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'guidePage',
  props: {
  leadsData: {
    type: Object,
    default: () => {
      return {};
    },
  },
},
  setup(__props) {

const props = __props;

// 是否登录
const isLogin = computed(() => {
  return store.state.base.token ? true : false;
});

// // 是否售后运营角色
// const isAsyunying = computed(() => {
//   const temp = store.state.base.userInfo.roleMetaList.filter(
//     (item) => item.alias === "asyunying"
//   );
//   return temp.length > 0;
// });

// 未登录状态 显示的默认数据
const displayUnLoginCards = [
  {
    title: "保养线索产值",
    nums: "1000万+",
    unit: "元",
    img: MaintenanceIcon,
  },
  {
    title: "故障线索产值",
    nums: "300万+",
    unit: "元",
    img: FaultIcon,
  },
  {
    title: "事故线索产值",
    nums: "200万+",
    unit: "元",
    img: AccidentIcon,
  },
  {
    title: "续保成功单数",
    nums: "1000+",
    unit: "单",
    img: RenewalIcon,
  },
];

// 登录状态
const displayAfterSaleCards = computed(() => {
  return [
    {
      title: "保养线索",
      siteRate: props.leadsData?.maintenanceLeads?.entranceRate || "0.00%",
      ouputValue:
        (props.leadsData?.maintenanceLeads?.outputValue || "0") + "万",
      img: MaintenanceIcon,
    },
    {
      title: "维修线索",
      siteRate: props.leadsData?.faultLeads?.entranceRate || "0.00%",
      ouputValue: (props.leadsData?.faultLeads?.outputValue || "0") + "万",
      img: FaultIcon,
    },
  ];
});

// 登录后展示的保险线索进站率
const accidentLeadsRate = computed(
  () => props.leadsData?.accidentLeads?.entranceRate || "0.00%"
);

// 登录后展示的续保成功单数
const renewalNum = computed(
  () => props.leadsData?.insuranceLeads?.insuranceSuccessNum || 0
);

// 跳转到 线索详情 页面
const goLeadsPage = () => {
  console.log("11 :>> ", 11);
  // router.push({
  //   name: "asLeads",
  // });
  window.open(`${window.location.origin}/asLeads`);
};

onMounted(() => {
  // console.log("mounted");
});

onUnmounted(() => {
  // console.log("unmounted");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title" }, "售后线索大数据增效平台", -1)),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "desc" }, " 基于售后维保及车联数据，构建保养预测、事故及故障识别等模型，向服务站精准推送售后维保线索，提升用户进站率及售后配件营收。 ", -1)),
    _createElementVNode("div", {
      class: "jump-button",
      onClick: goLeadsPage
    }, "查看线索"),
    (isLogin.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayAfterSaleCards.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card-item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.siteRate), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "item-wrapper-title" }, "30天进站率", -1))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(item.ouputValue), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "item-wrapper-title" }, "产值", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: item.img
                }, null, 8, _hoisted_10)
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_11, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "item-title" }, "保险线索", -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(accidentLeadsRate.value), 1),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "item-wrapper-title" }, "30天进站率", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("img", { src: _unref(AccidentIcon) }, null, 8, _hoisted_16)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "item-title" }, "续保成功单数", -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", null, _toDisplayString(renewalNum.value), 1),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "unit" }, "单", -1))
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("img", { src: _unref(RenewalIcon) }, null, 8, _hoisted_20)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(displayUnLoginCards, (item, index) => {
            return _createElementVNode("div", {
              class: "card-item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", null, _toDisplayString(item.nums), 1),
                _createElementVNode("span", _hoisted_24, _toDisplayString(item.unit), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("img", {
                  src: item.img
                }, null, 8, _hoisted_26)
              ])
            ])
          }), 64))
        ]))
  ]))
}
}

})